import React from 'react';
import HeroSection from './components/HeroSection';
import Navbar from '../../components/Navbar';
import Benefits from './components/Benefits';
import Pricing from './components/Pricing';
import Testimonials from './components/Testimonials';
import Footer from './components/Footer';
import FAQ from './components/FAQ';
import PrivacyCommitment from './components/PrivacyCommitment';

const LandingPage = () => {
  return (  
    <div className="min-h-screen bg-[#f5f5f5]">
      <Navbar />
      <HeroSection />
      <Benefits />
      <Pricing />
      <Testimonials />
      <PrivacyCommitment />
      <FAQ/>
      <Footer />
      </div>
  );
};

export default LandingPage;